import { environment } from '../../../environments/environment';

// Gateway del backend según el ambiente del build (environment.ts en main,
// environment.development.ts en develop). Única fuente de la URL de la API: servicios e
// interceptores la importan desde acá.
export const API_BASE_URL = `${environment.apiBaseUrl}/api/v1`;
